import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-numberpicker',
  templateUrl: './numberpicker.component.html',
  styleUrls: ['./numberpicker.component.scss']
})
export class NumberpickerComponent implements OnInit {

  @Input() model: number = 0;

  @Output() modelChange = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  prev() {
    this.model--;
    if (this.model < 0) {
      this.model = 0;
    }
    this.modelChange.emit(this.model);
  }

  next() {
    this.model++;
    this.modelChange.emit(this.model);
  }

  change(event: Event) {
    this.model = parseInt((event.target as HTMLInputElement).value);
    if (this.model < 0) {
      this.model = 0;
    }
    this.modelChange.emit(this.model);
  }

}
